import { MountingPart } from 'app/features/configuratorData/slice/types';
import { ItemsPriceType } from 'app/features/price/slice/types';
import { StockStatusType } from 'app/features/stock/slice/types';

export const transformMountingPart: (
  mountingPart: MountingPart,
  mountingPartPrice: Array<ItemsPriceType>,
  mountingPartStock: Array<StockStatusType>,
) => any = (
  mountingPart: MountingPart,
  mountingPartPrice: any,
  mountingPartStock: any,
) => {
  return {
    ...mountingPart,
    price: mountingPartPrice && mountingPartPrice[0],
    stockStatus: mountingPartStock && mountingPartStock[0],
  };
};
